import { mapState } from 'vuex';
import { mq } from 'util/dom/mq';

export default {
    computed: {
        ...mapState('viewport', ['mq']),
        isMobile() {
            return this.mq && mq('<=sm');
        },
    },
};
